export const EVAL_MODAL_NAMES = {
  reassignSpecialist: 'reassignSpecialist',
  triggerHandoff: 'triggerHandoff',
};

export const FAILURE_REASONS = {
  NO_TRAINED_COACH: {
    label: 'No trained coach',
    detail: 'Nobody is first-class trained for this pool. Escalate to supply.',
    fixable: false,
  },
  NO_LICENCE_MATCH: {
    label: 'No licence match',
    detail: 'No coach is licensed for this grade and region. Escalate to supply.',
    fixable: false,
  },
  ALL_INACTIVE: {
    label: 'All inactive',
    detail: 'Every matching coach is blocked, growth-off or suspended.',
    fixable: false,
  },
  NO_PROFILE: {
    label: 'No teaching profile',
    detail: 'Licensed coaches exist but none has a teaching profile.',
    fixable: false,
  },
  NO_SLOT_MATCH: {
    label: 'No coach free at these slots',
    detail: 'Coaches exist for this student, but none is free at the chosen hours.',
    fixable: true,
  },
  ALL_AT_CAP: {
    label: 'All at capacity',
    detail: 'Coaches were free at these slots and the allocation cap removed every one.',
    fixable: true,
  },
  UNKNOWN: {
    label: 'Unknown',
    detail: 'No filter reports zero — this is worth a bug report.',
    fixable: false,
  },
};

export const AGE_BANDS = {
  FRESH: { label: 'Fresh' },
  AGEING: { label: 'Ageing' },
  BREACHED: { label: 'Over 24h' },
};

export const ELIGIBILITY_GATES = {
  licence: 'Licensed for this grade and region',
  active: 'Active and receiving students',
  profile: 'Has a teaching profile',
  available_at_requested_slots: 'Free at the requested slots',
  within_capacity: 'Within allocation capacity',
};

export const formatAge = hours => {
  if (hours === null || hours === undefined) return '-';
  if (hours < 1) return '<1h';
  if (hours < 24) return `${Math.floor(hours)}h`;

  return `${Math.floor(hours / 24)}d`;
};

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = value => UUID_REGEX.test((value || '').trim());

export const PREP_STATUSES = [
  {
    key: 'OWED',
    label: 'Owed',
    hint:
      'The parent has paid, but this card is not armed yet. Readiness waits for a first class.',
  },
  {
    key: 'RAISED',
    label: 'Raised',
    hint: 'The card is with the coach and its deadline is running.',
  },
  {
    key: 'COMPLETED',
    label: 'Completed',
    hint: 'The coach finished this step.',
  },
  {
    key: 'OVERDUE',
    label: 'Overdue',
    hint:
      'The deadline passed with the card still open. Handoff is due 4 days after it is raised; readiness 1 hour before the first class.',
  },
  {
    key: 'NEVER_PUSHED',
    label: 'Never pushed',
    hint:
      'No card was ever created: the training tool never registered this student, so nothing was raised and the coach was never told. Use Trigger Student Handoff once that is fixed.',
  },
];

export const PREP_STATUS_HINTS = PREP_STATUSES.reduce(
  (acc, { key, hint }) => ({ ...acc, [key]: hint }),
  { NOT_OWED: 'Nothing is owed for this step yet.' },
);

export const PREP_STEPS = [
  { key: 'STUDENT_HANDOFF', label: 'Handoff' },
  { key: 'STUDENT_READINESS', label: 'Readiness' },
];

// DISPUTED and PENDING_REVIEW exist on the model but nothing writes them, so they
// are not offered as filters.
export const VIOLATION_STATUSES = ['ACTIVE', 'REVERSED'];

export const VIOLATION_STATUS_HINTS = {
  ACTIVE: "Charged. These points are held against the coach's compliance rating.",
  REVERSED: 'Withdrawn. The points went back as soon as it was reversed.',
};

export const VIOLATION_SEVERITY_HINTS = {
  MINOR: 'Lightest band. The points come from the compliance config, not this screen.',
  MILD: 'Second band.',
  MODERATE: 'Third band.',
  SEVERE: 'Heaviest band, and the largest deduction.',
};

export const formatEpochIst = epoch => {
  if (!epoch) return '—';

  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(Number(epoch) * 1000));
};

// Wire values written by the parent survey; labels match what the parent saw.
export const COMFORT_LABELS = {
  MOSTLY_COMFORTABLE: 'Mostly comfortable',
  LUKEWARM: 'Lukewarm',
  DID_NOT_CONNECT: "Didn't really connect",
};

export const PACE_LABELS = {
  TOO_FAST: 'Too fast',
  JUST_RIGHT: 'Just right',
  TOO_SLOW: 'Too slow',
};
